module.exports = "/_next/static/images/CollectAndBuild@2x-c41a79cd578e53b85269b7155221c99b.webp";